// src/partners/partnerApplicationsApi.ts
import { apiClient } from "@maat/api-base";
var partnerApplicationsApi = {
  me: async () => {
    return apiClient.get("/main/api/partner-applications/me");
  },
  /** Create or resubmit (a rejected application flips back to pending). */
  save: async (data) => {
    return apiClient.post("/main/api/partner-applications", data);
  },
  /** Withdraw a still-pending application. */
  withdraw: async () => {
    await apiClient.delete("/main/api/partner-applications");
  }
};

export {
  partnerApplicationsApi
};
